"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _react = _interopRequireDefault(require("react"));
var _localization = require("@lt/localization");
var _SearcherFilters = _interopRequireDefault(require("../SearcherAbstractFilters/SearcherFilters"));
var SearcherFormFilters = function SearcherFormFilters(_ref) {
  var className = _ref.className,
    addServicesFilters = _ref.addServicesFilters,
    activeFilters = _ref.activeFilters,
    onSubmitFilters = _ref.onSubmitFilters,
    isMobile = _ref.isMobile,
    isHotelOnly = _ref.isHotelOnly,
    isOpenFiltersList = _ref.isOpenFiltersList;
  var _useTranslation = (0, _localization.useTranslation)(),
    t = _useTranslation.t;
  return /*#__PURE__*/_react["default"].createElement(Container, {
    className: className,
    isMobile: isMobile
  }, !(0, _isEmpty2["default"])(addServicesFilters) && /*#__PURE__*/_react["default"].createElement(_SearcherFilters["default"], {
    key: String(Object.values(activeFilters || {})),
    activeFilters: activeFilters,
    options: addServicesFilters,
    onSubmit: onSubmitFilters,
    isMobile: isMobile,
    isHotelOnly: isHotelOnly,
    isOpenFiltersList: isOpenFiltersList
  }));
};
var Container = _styledComponents["default"].div.withConfig({
  displayName: "SearcherFormFilters__Container",
  componentId: "sc-deen4b-0"
})(["display:flex;justify-content:", ";", ""], function (_ref2) {
  var isMobile = _ref2.isMobile;
  return isMobile ? 'space-between' : 'flex-start';
}, function (_ref3) {
  var isMobile = _ref3.isMobile;
  return isMobile && 'width: 100%;';
});
var _default = exports["default"] = SearcherFormFilters;